import { autoinject } from 'aurelia-framework';
import { Zone } from "../../../models/zone";


export class GpsLocation {
	latitude: number;
	longitude: number;
}
@autoinject
export class GoogleMapZone {
	zone: Zone;
	markers: Array<GpsLocation> = new Array<GpsLocation>();

	constructor() {

	}

	bind(bindingContext: any, overrideContext: any) {
		this.zone = bindingContext.zone;
	}

	attached() {
		this.renderDevices();
	}

	renderDevices() {
		// TODO: clear all markers
		for (let structure of this.zone.structures) {
			for (let device of structure.devices) {
				//{"type":"position","latitudeDeg":44.1505959,"longitudeDeg":-121.2867375,"inTrip":false,"fixFailed":false,"headingDeg":264.375,"speedKmph":1,"battery":4800,"manDown":false,"timestamp":"2019-07-09T04:02:10","rssi":-115}
				const data = device.data;
				this.markers.push({ "latitude": data.latitudeDeg, "longitude": data.longitudeDeg });
				//this.map.addMarker({ "lat": data.latitudeDeg, "lng": data.longitudeDeg },
				//	JSON.stringify(device.data),
				//	"Devices");
				//this.map.addMarker({ "lat": data.latitudeDeg, "lng": data.longitudeDeg },
				//	JSON.stringify(device.data));
			}
		}
	}

}